export default "skymp5-front/96d76a77611fa38bbbde3b3cc40050a1.jpg";